import { render } from "./BasicButton.vue?vue&type=template&id=4a8ad2ee&ts=true"
import script from "./BasicButton.vue?vue&type=script&lang=ts"
export * from "./BasicButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__